module.exports = __webpack_public_path__ + "img/PK_Info_Game2.a515b825.png";